'use strict';

var React = require('react');

var SvgChartHistogramSecondLastIcon = function SvgChartHistogramSecondLastIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 9.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 .75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 9.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 .75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 9.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 .75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 3a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-1.5 0v-12.5a.75.75 0 0 1 .75-.75Z"
  }));
};
SvgChartHistogramSecondLastIcon.displayName = "ChartHistogramSecondLastIcon";

exports.SvgChartHistogramSecondLastIcon = SvgChartHistogramSecondLastIcon;
